export interface IMenuItem {
    path: string
    title: string
    icon: string
    children?: IMenuItem[]
    isClient?: boolean
    hasManageTopIds?: boolean
}
export const menuList: IMenuItem[] = [
    {
        path: '/recycle/',
        title: '回收站',
        icon: 'co-icon-delete',
    },
    {
        path: '/unExpiredFile/',
        title: '交付文件',
        icon: 'el-icon-document',
    },
    {
        path: '/accessRequest/',
        title: '权限申请',
        icon: 'co-icon-approval',
    },
    {
        path: '/accessManage/',
        title: '权限管理',
        icon: 'co-icon-file',
        hasManageTopIds: true,
    },
    {
        path: '/taskList',
        title: '任务列表',
        icon: 'el-icon-document',
        isClient: true,
    },
]

// export const UPLOAD_STATUS = {
//   success: "上传成功",
//   error: "上传失败",
//   uploading: "上传中...",
//   paused: "暂停中",
//   waiting: "等待中"
// };

export const transferThreshold = 2 * 1024 * 1024 * 1024
// "pause" | "pre-downloading" | "downloading" | "finished" | "merging" | "error";
export const DOWNLOAD_STATUS = {
    pause: '暂停',
    'pre-downloading': '待下载',
    downloading: '下载中',
    finished: '完成',
    merging: '合并中',
    error: '错误',
}

export const UPLOAD_STATUS = {
    pause: '暂停',
    'pre-uploading': '待上传',
    uploading: '上传中',
    finished: '完成',
    error: '错误',
}
export enum ErrorCode {
    NO_LOGIN = 2,
    NORMAL_E = 1,
    NETWORK_E = 3,
}

export enum UNZIP_COMPRESS_STATUS_CODE {
    DOING = 1,
    DONE = 2,
    FAILED = 3, // 不可重试
    ERROR_RETRY = 4, // 可重试
}

export interface Operates {
    label: string
    content?: string
    value: number
}
export const OperateLabelList = ['上传', '下载', '删除', '压缩/解压', '新建文件夹', '移动/复制', '重命名', '权限审批']
export const operates: Operates[] = [
    {
        label: OperateLabelList[0],
        content: '',
        value: 1,
    },
    {
        label: OperateLabelList[1],
        content: '',
        value: 2,
    },
    {
        label: OperateLabelList[4],
        content: '',
        value: 5,
    },
    {
        label: OperateLabelList[5],
        content: '',
        value: 6,
    },
    {
        label: OperateLabelList[3],
        content: '',
        value: 4,
    },
    {
        label: OperateLabelList[2],
        content: '',
        value: 3,
    },
    {
        label: OperateLabelList[6],
        content: '',
        value: 7,
    },
    {
        label: OperateLabelList[7],
        content: '',
        value: 8,
    },
]

export enum FilePower {
    PREVIEW = 0,
    UPLOAD,
    DOWNLOAD,
    DELETE,
    UNZIP_COMPRESS,
    MKDIR,
    MOVE_COPY,
    RENAME,
    APPROVAL,
}

// 环境
export const envMap = {
    dev: {
        name: '开发环境',
        hostname: 'manage-dev.ait.wanyol.com/',
        fileHost: 'http://dev-file-system.ait.wanyol.com/',
    },
    test: {
        name: '测试环境',
        hostname: 'manage-test.ait.wanyol.com/',
        fileHost: 'http://file-system.test.ait.wanyol.com/',
    },
    prod: {
        name: '生产环境',
        hostname: 'manage.ait.oppoer.me/',
        fileHost: 'http://file-system.ait.oppoer.me/',
    },
}
interface AxiosDefaultMessage {
    [key: string]: {
        fail?: string
        success?: string
    }
}
export const axiosDefaultMessage: AxiosDefaultMessage = {
    '/api/dirPower': { fail: '获取失败' },
    '/api/grantPower': { fail: '授权失败', success: '授权成功' },
    '/api/listApproval': { fail: '获取失败' },
    '/api/operateApproval': { fail: '操作失败', success: '操作成功' },
    '/api/applicant': { fail: '申请失败', success: '权限申请成功' },
    '/api/applicantList': { fail: '获取权限列表失败' },
    '/api/getCode': { fail: '获取权限码失败' },
    '/api/getDevAccount': { fail: '查询失败' },
    '/api/dirStats': { fail: '获取失败' },
    '/api/cancelCompressOrUnzip': { fail: '操作失败', success: '取消成功' },
    '/api/fileDownloadUrl': { fail: '链接生成失败' },
    '/api/checkBeforeDownload': { fail: '下载失败' }
}

export function getOperateLabel(powers: number[]): string {
    const labelList = powers
        .map(power => {
            return !!power && OperateLabelList[power - 1]
        })
        .filter(item => item)
    return labelList.join('、')
}

export enum AccessState {
    pedding,
    pass,
    refuse,
}

export enum AccessStateLabel {
    pedding = '审批中',
    pass = '已通过',
    refuse = '已拒绝',
}
